module.exports = __webpack_public_path__ + "img/MoodBoard.280db715.png";